import { render } from "./PreviewSendEdit.vue?vue&type=template&id=17746dae"
import script from "./PreviewSendEdit.vue?vue&type=script&lang=js"
export * from "./PreviewSendEdit.vue?vue&type=script&lang=js"

import "./PreviewSendEdit.vue?vue&type=style&index=0&id=17746dae&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__